import { Judge } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAssignedJudge: (
  fetchContext: FetchContext,
  nominationId: number,
  userId: number,
  countryId?: number,
  accessToken?: string,
) => Promise<Judge> = (fetchContext, nominationId, userId, countryId, accessToken) => {
  const judgesPath = countryId === undefined ? 'judges' : `country/${countryId}/judges`;

  return fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}/${judgesPath}/${userId}`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Judge>(fetchContext.errorStore, response, 'get assigned judge'));
};
